import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CrownIcon, LayoutGridIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { offerItems, TOTAL_VALUE } from './data';
// Request a lighter, WebP version from the CDN to speed up mobile loads.
function optimized(url: string, width = 480) {
  if (!url.includes('cdn.magicpatterns.com')) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}w=${width}&q=70&fm=webp`;
}
export function ValueStack() {
  return <section className="relative w-full bg-ink-950 py-12 sm:py-16" data-id="element-289">
      <div className="absolute inset-0 bg-radial-cyan opacity-50" aria-hidden="true" data-id="element-290" />
      <div className="relative mx-auto max-w-6xl px-5" data-id="element-291">
        <SectionHeading eyebrow="La Oferta" data-id="element-292">
          Lo que vas a recibir hoy mismo
        </SectionHeading>

        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-293">
          {offerItems.map((item, i) => <Reveal key={item.tag} delay={i % 3 * 0.1} data-id="element-294">
              <motion.article whileHover={{
            y: -6
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 22
          }} className={`group relative flex h-full flex-col overflow-hidden rounded-3xl border bg-ink-800/60 shadow-card ${item.highlight ? 'border-accent/50 shadow-glow-cyan' : 'border-white/8'}`} data-id="element-295">
                <div className="relative aspect-[4/3] overflow-hidden bg-ink-900" data-id="element-296">
                  {item.image ? <img src={optimized(item.image)} alt={`Portada de ${item.title}`} width={480} height={360} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" decoding="async" data-id="element-297" /> : <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-ink-800 to-ink-900" data-id="element-298">
                      <div className="absolute inset-0 bg-lab-grid opacity-20" aria-hidden="true" data-id="element-299" />
                      <LayoutGridIcon className="relative h-16 w-16 text-accent transition-transform duration-500 group-hover:scale-110" strokeWidth={1.25} aria-hidden="true" data-id="element-300" />
                    </div>}
                  <span className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest ${item.highlight ? 'bg-accent text-ink-950' : 'bg-black/60 text-accent-light ring-1 ring-accent/30'}`} data-id="element-301">
                    {item.highlight && <CrownIcon className="h-3 w-3" aria-hidden="true" data-id="element-302" />}
                    {item.tag}
                  </span>
                  <span className="absolute right-3 top-3 rounded-full bg-black/70 px-2.5 py-1 text-xs font-bold text-white ring-1 ring-white/20" data-id="element-303">
                    {item.value} Valor
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-5" data-id="element-304">
                  <h3 className="font-heading text-lg font-extrabold text-white" data-id="element-305">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-silver/70" data-id="element-306">
                    {item.description}
                  </p>
                  <p className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-accent" data-id="element-307">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-308" />{' '}
                    Incluido hoy
                  </p>
                </div>
              </motion.article>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-309">
          <div className="mx-auto mt-8 flex max-w-md flex-col items-center rounded-3xl border border-accent/30 bg-gradient-to-br from-ink-800 to-ink-900 p-8 text-center shadow-glow-cyan" data-id="element-310">
            <span className="text-xs font-bold uppercase tracking-widest text-silver/60" data-id="element-311">
              Valor Total
            </span>
            <span className="mt-2 font-display text-5xl tracking-tight text-cyan-gradient sm:text-6xl" data-id="element-312">
              {TOTAL_VALUE}
            </span>
            <span className="mt-2 text-sm text-silver/60" data-id="element-313">
              en valor real entregado hoy
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}